module.exports = __webpack_public_path__ + "static/media/dcp-logo-whitetext.92801ece.svg";